import { useState } from "react";
import { DeleteRestObjectButton } from "../../rest/components/DeleteRestObjectButton";
import { Abbreviation, Language } from "../../rest/models";
import { Button } from "../RequestRespectingInputs";
import { AbbreviationEditForm } from "./AbbreviationEditForm";

export function AbbreviationListRow(props: Props)
{
    const a = props.abbr;
    const [isEditing, setIsEditing] = useState(false);

    if (isEditing)
    {
        //Create an edit form.
        return (
            <tr className='ernots_CreateFormWrapper' key={a.key}>
                <td colSpan={4}>
                    <AbbreviationEditForm abbr={a} lang={props.lang} onDone={() => setIsEditing(false)}/>
                </td>
            </tr>)
    }
    else
    {
        return (
            <tr className='ernots_ModelRow'>
                <td style={{fontStyle: a.public ? "italic" : undefined}}>{a.text}</td>
                <td className='ernots_CenteredCell'><Button onClick={e => setIsEditing(true)}>Edit</Button></td>
                <td className='ernots_CenteredCell'><DeleteRestObjectButton object={a} messageOnNewLine={true}/></td>
            </tr>
        );
    }
}

interface Props
{
    abbr: Abbreviation;
    lang: Language
}